'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const Topbar = dynamic(
  () => import('@/design-system/topbar/topbar').then((mod) => mod.default),
  { ssr: false }
);

export default function HeaderWrapper({
  hideNavLinks,
}: {
  hideNavLinks?: boolean;
}) {
  return <Topbar hideNavLinks={hideNavLinks} />;
}
